import { LocalizedString } from "../../../services/general/models";
import { makeAutoObservable, action } from "mobx";
import { TranslationServiceTranslateTextRequest } from "../../../services/menu/requestsResponses";
import { getTranslate } from "../../../services/menu";
import { MenuAvailableLanguages } from "../../../services/menu/models";
import { toLocalizedString } from "../../libs";

export interface LocalizedInputProps {
    label: string,
    value: LocalizedString,
    setNewValue: (v: LocalizedString) => void;
    numberOfLines?: number
}

class TranslationStore {
    constructor() {
        makeAutoObservable(this);
    }

    value: LocalizedString;
    label: string = "";
    numberOfLines: number = 1;
    newValue: (v: LocalizedString) => void;

    translationEditorForm: {
        current?: LocalizedString,
        open: boolean,
    } = { open: false }

    availableLanguages: string[] = [];


    async autoTranslate(data: TranslationServiceTranslateTextRequest) {
        const response = await getTranslate(data);
        return response;
    }


    @action
    setLangs(languages: MenuAvailableLanguages) {
        let langs: string[] = [];
        for (let [key, value] of Object.entries(languages)) {
            // @ts-ignore
            if (value.isEnabled === true) {
                langs.push(key);
            }
        }
        if (langs.length === 0) {
            langs = ["ru", "en", "zh", "it"];
        }
        this.availableLanguages = langs;
    }

    @action
    showTranslationEditorForm(current?: LocalizedString) {
        this.translationEditorForm.open = true;
        this.translationEditorForm.current = current;
    }

    @action
    closeTranslationEditorForm() {
        this.translationEditorForm.open = false;
        this.translationEditorForm.current = undefined;
        this.numberOfLines = 1;
        this.availableLanguages = ["ru", "en", "zh", "it"];
    }

    @action
    setValue(value: LocalizedString | null) {
        this.value = value || toLocalizedString("");
    }

    @action
    setLabel(label: string) {
        this.label = label;
    }

    @action
    setNumberOfLines(v: number) {
        this.numberOfLines = v;
    }

    @action
    setNewValue(foo: (v: LocalizedString) => void) {
        this.newValue = foo;
    }

}

export default TranslationStore
